import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LandingPageComponent } from '../landing-page/landing-page.component';
import { ShareviewComponent } from '../shareview/shareview.component';
import { AppStoreLinkComponent } from '../app-store-link/app-store-link.component';
import { MaintenanceComponent } from '../maintenance/maintenance.component';
import { CauthComponent } from '../cauth/cauth.component';
import { LoginComponent } from '../login/login.component';
import { DuplicateAppleId } from '../duplicateappleid/duplicateappleid.component';
import { BecomeComponent } from '../become/become.component';
import { PasswordResetComponent } from '../password-reset/password-reset.component';
import { HomeComponent } from '../home/home.component';
import { SessionsComponent } from '../sessions/sessions.component';
import { SessionComponent } from '../session/session.component';
import { FriendsComponent } from '../friends/friends.component';
import { UserComponent } from '../user/user.component';
import { MydataComponent } from '../mydata/mydata.component';
import { WorkoutEditorComponent } from '../workout-editor/workout-editor.component';
import { WorkoutListComponent } from '../workout-list/workout-list.component';
import { WorkoutViewComponent } from '../workout-view/workout-view.component';
import { PagesComponent } from '../pages/pages.component';
import { BoardsComponent } from '../boards/boards.component';
import { ErrorComponent } from '../error/error.component';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { SixSecondBoardComponent } from '../six-second-board/six-second-board.component';
import { RoleCanActivateRouteGuard } from './role-can-activate-route.guard';
import { FiveKBoardComponent } from '../five-k-board/five-k-board.component';
// Routes
const appRoutes: Routes = [
  // { path: '**', component: MaintenanceComponent },
  { path: '', component: LandingPageComponent },
  { path: 'share/workout/:id/:title', component: ShareviewComponent },
  { path: 'sl', component: AppStoreLinkComponent }, // app store links
  { path: 'login', component: LoginComponent },
  { path: 'duplicateappleid', component: DuplicateAppleId },
  { path: 'become/:sessionToken', component: BecomeComponent },
  { path: 'password-reset', component: PasswordResetComponent },
  { path: 'home', component: HomeComponent },
  { path: 'home/:id', component: HomeComponent },
  { path: 'sessions', component: SessionsComponent },
  { path: 'session/:id', component: SessionComponent },
  { path: 'sixnations', component: SixSecondBoardComponent },
  { path: '5k', component: FiveKBoardComponent },
  { path: 'friends', component: FriendsComponent },
  { path: 'mydata', component: MydataComponent },
  { path: 'user/:id', component: UserComponent },
  { path: 'workouts/edit/:id', component: WorkoutEditorComponent },
  { path: 'workouts/view/:id', component: WorkoutViewComponent },
  { path: 'workouts/create', component: WorkoutEditorComponent },
  { path: 'workouts', component: WorkoutListComponent },
  { path: 'pages/:id', component: PagesComponent },
  { path: 'boards/:workout_id', component: BoardsComponent },
  { path: 'cauth/:action', component: CauthComponent },
  { path: 'error', component: ErrorComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/app-routing/app-routing.module.ts